module.exports = __webpack_public_path__ + "static/media/in-service-icon-card.187d0348.svg";